import { setAxiosConfig, setHZAxiosConfig } from '@hz-insights/web-components/dist/src/components/Service/config.js'

const config = {
  baseURL: process.env.REACT_APP_API_BASEURL,
  timeout: 500000
}

setAxiosConfig(config)
setHZAxiosConfig(config)
